import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class SpecService extends BaseService {

    static url = "specs";
    static apis = {
        that: this,
        filter_specs: this.url + "/filter_specs",
      
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("specs");
    }

    
    getFilterSpecs() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: SpecService.apis.filter_specs, method: "GET", authorization: false, showLoader: false })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

}

export default SpecService;